<template>
    <div class="header">
        <div class="backBtn" @click="back">
            <i class="icons icon-back"></i>
        </div>
        <span>{{headerData.name}}</span>
        <span v-if="headerData.save" class="saveBtn" @click="save">保存</span>
        <span v-if="headerData.manage" class="saveBtn" @click="manage">管理</span>
    </div>
</template>

<script>
    export default {
        name: 'header',
        props: ['headerData'],
        methods: {
            back(){
//            && window.webView
                if (this.headerData.isOut ) {
                    var routeName=this.$route.name;
                    if(routeName=='chooseAddress'){
//                      var addressData = JSON.stringify(this.headerData.addressData);
//                      window.webView.exchange("back", addressData)
                      this.$smartBridge.setResult({ postData: { back:true,addressData: this.headerData.addressData } });
                      this.$smartBridge.close();
                    }else{
                      this.$smartBridge.close();
//                        window.webView.close()
                    }
                } else {
                    this.$router.go(-1);
                }
            },
            save(){
                if (this.headerData.save) {
                    this.$emit(this.headerData.save)
                }
            },
            manage(){
                var addressManageData={
                        name: '收货地址管理',
                        isOut: false,
                        save: false
                }
                this.$router.push({name: 'addressList', query: {platform:this.headerData.platform,headerData:addressManageData}})
            }
        },
        data () {
            return {}
        }
    }
</script>
<style scoped>
    .header {
        height: 44px;
        font-size: 16px;
        color: #fff;
        background: #2f80ed;
        line-height: 44px;
        font-weight: 600;
        position: fixed;
        width: 100%;
        left: 0;
        top: 0;
        z-index: 1000;
    }

    .saveBtn {
        position: absolute;
        min-width: 40px;
        right: 5px;
    }

    .backBtn {
        position: absolute;
        min-width: 40px;
        height: 44px;
        line-height: 52px;
    }
</style>



// WEBPACK FOOTER //
// src/components/header.vue